module.exports = __webpack_public_path__ + "img/unionpay.9b59a572.svg";